<template>
  <div>
    <div v-if="!isAuthenticationGranted">
      <!-- nic nezobrazit -->
    </div>
    <div v-if="isAuthenticationGranted">
        <gov-button :wcag-label="$t('user.login')" variant="primary" type="solid" size="m" hoverable class="gov-button-logout" @gov-click="logoutClickHandler">
          <span class="material-icons"> logout </span>
          {{ $t("user.logout") }}
          <v-idle @idle="onIdle" :duration="1200" style="display: none"/>
        </gov-button>
    </div>
  </div>
</template>

<script>
import router from "@/router";

export default {
  name: "CartControl",
  data() {
    return {
      isAuthenticationGranted: null,
    };
  },
  mounted() {
    this.$backend.getAuthenticationStatus(reponse => {
      this.isAuthenticationGranted = reponse.data.authenticationGranted;
    });
  },
    methods: {
      onIdle() {
        this.logout();
      },
      // Log the user out
      logout() {
        if (this.isTestovaci)
          this.$backend.testLogout(response => this.testlogout());
        else
          router.push("/" + this.$customerUuid + "/logout");
      },
      async testlogout() {
        var buOrganizace = this.$store.state.organizace;
        this.$store.dispatch("resetAndSetGlobalLoadingToTrue");

        if (window.location.pathname.split("/").length > 2)
          router.push("/" + this.$customerUuid);
        else
          this.$router.go(0);

        this.$store.dispatch("setOrganizace", buOrganizace);
        await new Promise(r => setTimeout(r, 250));
        this.$store.dispatch("setGlobalLoading", false);
      },
        logoutClickHandler() {
            console.log("logoutClickHandler");
            this.logout();
        },
    },
};
</script>
